import { render, staticRenderFns } from "./kf-email.vue?vue&type=template&id=50c8e280&scoped=true"
import script from "./kf-email.vue?vue&type=script&lang=js"
export * from "./kf-email.vue?vue&type=script&lang=js"
import style0 from "./kf-email.vue?vue&type=style&index=0&id=50c8e280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c8e280",
  null
  
)

export default component.exports